import { useEffect } from 'react';

const Authenticated = ({ setState }) => {
  useEffect(() => {
    setState('READY');
  }, [setState]);
  return <div>Authenticated</div>;
};
export default Authenticated;
